function formatAsSoonAsDate(
  utcString?: string,
  timeZone?: string,
  shortOrLong: 'long' | 'short' = 'long'
) {
  if (!utcString || !timeZone) return null;

  const utcDate = new Date(utcString);

  return utcDate.toLocaleDateString('en-us', {
    weekday: shortOrLong,
    month: shortOrLong,
    day: 'numeric',
    timeZone
  });
}

export default formatAsSoonAsDate;
